module.exports = __webpack_public_path__ + "media/images/quote-white-64ec081b898212457e5605c4850e0b3d.svg";